<div class="po-row po-mb-1">
    <div class="po-xl-10 po-lg-10 po-md-9 po-sm-12">
        <p class="po-font-title">Balanço</p>
    </div>
    <div class="po-xl-2 po-lg-2 po-md-2 po-sm-12 po-text-right po-mt-2">
        <po-button p-label="Filtros" p-icon="{{seeFilter ? arrowDown : funnelIcon }}"
            (p-click)="onSeeFilter()"></po-button>
    </div>
</div>
<po-widget class="po-lg-12 po-mb-1" *ngIf="seeFilter">
    <div [formGroup]="filterForm">
        <div class="po-xl-3 po-lg-3 po-md-12 po-sm-12">
            <p>Situação</p>
            <po-select formControlName="inventoryStatusFilter" [p-options]="statusItens"
                p-placeholder="Selecione uma Situação" [p-disabled]="true">
            </po-select>
        </div>
        <div class="po-xl-3 po-lg-3 po-md-12 po-sm-12">
            <p>Código de Balanço</p>
            <po-number formControlName="inventoryCodeFilter" p-placeholder="Digite o código de balanço"
                [p-maxlength]="20">
            </po-number>
        </div>
        <app-date-range [startDateControlName]="'startDate'" [endDateControlName]="'endDate'"
            [poClass]="'po-xl-3 po-lg-3 po-md-12 po-sm-12'" [required]="true">
        </app-date-range>
        <div class="po-lg-12 po-mb-1 po-mt-3">
            <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 po-text-left">
                <po-button p-label="Limpar" (p-click)="cleanFilter()"></po-button>
            </div>
            <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 po-text-right">
                <po-button [p-disabled]="filterForm.invalid" p-label="Aplicar filtro"
                    p-icon="an an-list-magnifying-glass" (p-click)="onFilter()"></po-button>
            </div>
        </div>
    </div>
</po-widget>
<div class="po-row po-mt-2 po-mb-5" [class.fade-in]="fadeInAnimation">
    <po-container *ngIf="inventoryItems.length > 0" class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <app-inventory-header-card (onOpenInventoryCount)="onInventoryHeaderSelected($event)"
            [inventories]="inventoryItems"></app-inventory-header-card>
    </po-container>
    <po-container *ngIf="inventoryItems.length == 0" class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center">
        <p>Nenhum item encontrado</p>
    </po-container>
</div>